import styled from 'vue-styled-components';
import theme from '@/config/theme';

export const Card = styled.div`
  width: 280px;
  height: 365px;
  background: ${theme.colors.white};
  box-shadow: ${theme.shadow.lv1};
  border-radius: 0.5rem;

  :hover {
    cursor: pointer;
  }

  img {
    width: 100%;
    height: 50%;
    border-radius: 0.5rem 0.5rem 0 0;
    pointer-events: none;
    user-select: none;
  }

  .infs {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    color: ${theme.colors.gray6};
    padding: 1rem;
    height: 50%;

    .title,
    .subTitle {
      display: block;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .title {
      font-size: 1rem;
      color: inherit;
      font-weight: bold;
      font-style: normal;
    }

    .subTitle {
      color: inherit;
      font-size: 0.9rem;
      font-style: normal;
    }
  }

  .isLoading {
    display: block;
    z-index: 2;
    width: 100%;
    height: 50%;
    background: #eee;
    background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
    background-size: 200% 100%;
    animation: 1.5s shine linear infinite;
    border-radius: 0.5rem 0.5rem 0 0;
  }

  @keyframes shine {
    to {
      background-position-x: -200%;
    }
  }

  @media screen and (max-width: ${theme.grid.tablet.breakpoint}) {
    display: flex;
    width: 327px;
    height: 126px;

    img {
      width: 123px;
      height: 100%;
      border-radius: 0.5rem 0 0 0.5rem;
    }

    .infs .hidden {
      display: none;
    }
  }
`;
